import { render } from "./AddAlt.vue?vue&type=template&id=705d116a&scoped=true"
import script from "./AddAlt.vue?vue&type=script&lang=js"
export * from "./AddAlt.vue?vue&type=script&lang=js"

import "./AddAlt.vue?vue&type=style&index=0&id=705d116a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705d116a"]])

export default __exports__